import { useLocation, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AlertEditingLayout } from 'components/layouts/AlertEditingLayout';
import { getPageStatus, PageLayout } from 'components/PageLayout';
import { AqiSensorAlertForm } from 'features/aqiSensors/components/AqiSensorAlertForm';
import { useAQISensor } from 'features/aqiSensors/hooks/useAQISensor';
import { useWeatherAlert } from 'features/weatherAlerts/hooks/useWeatherAlert';

export const AqiSensorEditAlert = (): JSX.Element => {
  const { stationId, alertId } = useParams<{
    stationId: string;
    alertId?: string;
  }>();
  const { t } = useTranslation();
  const location = useLocation<{ fromRoute?: string }>();
  const {
    aqiSensor,
    isLoading: isLoadingStation,
    isError: isErrorForStation,
  } = useAQISensor({
    id: parseInt(stationId, 10),
  });
  const {
    alert,
    isLoading: isLoadingAlert,
    isError: isErrorForAlert,
  } = useWeatherAlert({ alertId: alertId ? parseInt(alertId, 10) : undefined });

  const isLoading = !aqiSensor || isLoadingStation || isLoadingAlert;
  const isError = isErrorForStation || isErrorForAlert;

  const status = getPageStatus({
    isLoading,
    isError,
  });

  const returnRoute =
    location.state?.fromRoute || `/aqi/${stationId}?tab=notifications`;

  const title = alertId
    ? t('aqiSensors.alerts.editNotification')
    : t('aqiSensors.alerts.addNotification');

  return (
    <PageLayout
      data-cname="AqiSensorEditAlert"
      status={status}
      headerBarProps={{
        title,
        action: returnRoute,
      }}
    >
      {aqiSensor && (
        <AlertEditingLayout>
          <AqiSensorAlertForm
            aqiSensor={aqiSensor}
            alert={alert}
            fromRoute={returnRoute}
          />
        </AlertEditingLayout>
      )}
    </PageLayout>
  );
};
